import { getSpacesLandingQueryKey, getSpacesLandingV2QueryKey, getUserPinnedSpacesQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { getSidebarV2InitialQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/threadKeys.js';
import { unpinUserSpace } from '#pplx/frontend/apps/ask/queries/spaces-queries/unpinUserSpace.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
export function useUnpinUserSpace({ reason, }) {
    const queryClient = useQueryClient();
    const { session } = useSession();
    const queryKey = getUserPinnedSpacesQueryKey(session?.user?.email);
    return useMutation({
        mutationFn: async (collection) => {
            if (!collection?.uuid) {
                logger.log('no collection uuid found to useUnpinUserSpace');
                return;
            }
            return unpinUserSpace({ spaceUuid: collection.uuid, reason });
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: getSidebarV2InitialQueryKey() });
            queryClient.invalidateQueries({ queryKey });
            queryClient.invalidateQueries({ queryKey: getSpacesLandingQueryKey() });
            queryClient.invalidateQueries({ queryKey: getSpacesLandingV2QueryKey() });
        },
    });
}
//# sourceMappingURL=useUnpinUserSpace.js.map